import classNames from "classnames"
import { Dialog } from "primereact/dialog"
import React from "react"

function InfoDialog({ close }) {
  const header = (<h3 className="text-2xl"><b>Instruções para Importação de Dados de Inadimplentes</b></h3>)

  return (
    <Dialog
      visible
      onHide={() => close()}
      maximizable={true}
      header={header}
      pt={{
        root: ({ state }) => ({
          className: classNames('rounded-lg shadow-lg border-0', 'max-h-[90%] transform scale-100', 
            'm-0 w-[90vw]', 
            'dark:border dark:border-blue-900/40', {
            'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized
          })
        }),
        header: classNames('flex items-center justify-between shrink-0',
          'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
          'dark:bg-gray-900  dark:text-white/80'),
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[85vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow max-h-screen": state.maximized
          })
        }),
      }}
    >
      <div className="grid gap-3">
        <p>A funcionalidade de importação de inadimplentes permite o carregamento de listas de cobrança na plataforma.
           Para garantir um processo eficiente e sem erros
          , siga atentamente as instruções abaixo.</p>
        <h4 className="text-lg"><b>1. Como funciona o processo de importação?</b></h4>
        <div className="pl-6">
          <h5><b>1.	Envio do Arquivo</b></h5>
          <p>
            o	Clique na área destacada em verde ou arraste e solte o arquivo no espaço indicado.
          </p>
          <p>  
            o	O sistema aceitará apenas arquivos nos formatos <b>.csv, .xls ou .xlsx</b>. Outros formatos serão rejeitados automaticamente.
          </p>
          <h5><b>2.	Pré-Análise Automática</b></h5>
          <p>
            o	Após carregar o documento, o sistema realiza uma <b>pré-análise instantânea </b>do arquivo para identificar erros comuns, como formatação incorreta, campos em branco ou valores inválidos.
          </p>
          <p>  
            o	Se houver erros, eles serão apontados na tela, e você poderá corrigir antes do envio definitivo.
          </p>
          <h5><b>3.	Análise Final e Processamento</b></h5>
          <p>
            o	Após o envio, o sistema executará uma análise mais detalhada, descartando automaticamente as linhas com inconsistências.
          </p>
          <p>  
            o	As cobranças válidas serão carregadas na plataforma.
          </p>
          <h5><b>4.	Relatório de Importação</b></h5>
          <p>
            o	O resultado do carregamento pode ser consultado na seção <b>Histórico de Cargas</b> abaixo.
          </p>
          <p>  
            o	Um relatório detalhado poderá ser baixado clicando no botão roxo na linha da tabela relativa à carga enviada.
          </p>
        </div>

        <h4 className="text-lg"><b>2. Erros Comuns e Como Corrigir</b></h4>
        <div className="pl-6">
          <h5><b>🔹 Documento do Devedor Inválido (CPF/CNPJ)</b></h5>
          <p>✔ O sistema valida automaticamente os documentos dos devedores. Certifique-se de que:</p>
          <p>
            •	O formato da célula no Excel está definido como Texto, pois o programa pode remover zeros à esquerda automaticamente.
          </p>
          <p>
            •	O CPF/CNPJ foi digitado corretamente, pois o sistema verifica os dígitos verificadores e rejeita documentos inválidos.
          </p>
          <p><b>🔹 Data Inválida</b></p>
          <p>
            ✔ As datas devem estar no formato <b>dd/mm/aaaa</b> (padrão brasileiro) e ser anteriores à data atual.
          </p>
          <p><b>🔹 Colunas Ausentes ou Nomes Diferentes</b></p>
          <p>
            ✔ O arquivo deve conter <b>todas as colunas obrigatórias</b> conforme o modelo de exemplo disponível no botão "Arquivo de Exemplo".
          </p>
          <p><b>🔹 Cobranças com Erros</b></p>
          <p>
            ✔ Apenas as cobranças <b>válidas serão carregadas.</b> Se houver linhas com erro, edite o arquivo e reenvie para garantir um processamento completo.
          </p>
        </div>

        <h4 className="text-lg"><b>3. Perguntas Frequentes (FAQ)</b></h4>
        <div className="pl-6">
          <p><b>❓ O que acontece se meu arquivo contiver cobranças inválidas?</b></p>
          <p>
          ✅ Apenas as linhas corretas serão carregadas na plataforma. As inválidas podem ser ajustadas e reenviadas.
          </p>
          <p><b>❓ Como saber quais cobranças foram carregadas?</b></p>
          <p>
          ✅ O relatório de importação estará disponível na seção Histórico de Cargas com o status de cada cobrança.
          </p>
          <p><b>❓ Não consigo visualizar o relatório ou a pré-visualização da planilha. O que fazer?</b></p>
          <p>
          ✅ Verifique se o arquivo possui todas as colunas obrigatórias e está no formato correto. Arquivos sem os títulos padronizados não podem ser processados.
          </p>
        </div>

        <div>
          <p><b>📌 Dica:</b> Para garantir uma importação sem erros, sempre valide seu arquivo antes do envio utilizando o modelo disponível no botão "Arquivo de Exemplo".</p>
          <p>Caso tenha dúvidas, entre em contato com o suporte. 🚀</p>
        </div>
      </div>
    </Dialog>
  )
}

export default InfoDialog